import { useState, useCallback } from 'react';
import createStore from 'ctx-provider';

// Single-slot store that holds the currently-open numeric keypad (if any).
// Used by the on-screen numeric keypad ("number getter") on mobile.
const useNumericFeedback = () => {
	const [numericKeypadContent, setNumericKeypadContent] = useState(null);

	const add = useCallback(content => {
		setNumericKeypadContent(content);
	}, []);

	const remove = useCallback(() => {
		setNumericKeypadContent(null);
	}, []);

	return { numericKeypadContent, add, remove };
};

const store = createStore(useNumericFeedback);

export const { Provider } = store;
export default store.ctx;
